import { Input } from '@salecycle/ui-component-library';
import * as React from 'react';
import { connect } from 'react-redux';

import { ImpressionPathWhitelist } from 'entities/campaign';
import { Actions } from 'sections/campaigns/state/rulesets';
import { OwnProps, Props } from './props';

export type FormProps = Props<ImpressionPathWhitelist>;

export const Form: React.FC<FormProps> = (props: FormProps) => {
  const onChange = (value: string) =>
    props.update(props.rulesetId, props.ruleIndex, {
      whitelist: value.split(',').map((x: string) => x.trim()),
    });

  return (
    <div data-testid="ImpressionPathWhitelist">
      <Input
        label="Show when the URL path is one of (use commas to separate)"
        ariaLabel="Show when the url path is one of (use commas to separate)"
        inputId="UrlPathInput"
        onChange={onChange}
        value={props.rule.whitelist && props.rule.whitelist.join(', ')}
      />
    </div>
  );
};

export default connect<{}, {}, OwnProps>(null, { update: Actions.editRule })(Form);
